// Spec: specs/stats/questions/functional_requirements.md §6.10

import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { CAUSE } from '@aytm/app/stats/page/question-views/components/data-run/lib/causes'
import QuestionState from '@aytm/app/stats/page/question-views/components/data-run/QuestionState'

// This section has nothing to draw, and it has no job to run. What it does have, when the reader has
// set this section's own parameters, is something of theirs to put back -- so the state offers that
// rather than a run. The parameters are the section's settings, not a filter on respondents, so the
// offer names the section and does not claim they caused it.
const BadData = ({ sectionKey, reportParams = {}, colorTheme, onReset }) => {
  const configured = Boolean(reportParams?.[`vk${sectionKey}`])

  // Held only for the moment between the click and the section coming back cleared. What says
  // whether there is anything to reset is the section itself, so a block that had none when it
  // first drew must not still be answering for that once one arrives.
  const [resetting, setResetting] = useState(false)

  useEffect(() => {
    setResetting(false)
  }, [configured])

  const handleReset = () => {
    setResetting(true)
    onReset()
  }

  return (
    <QuestionState
      type="vk"
      cause={CAUSE.couldNotCalculate}
      action={configured ? { label: 'Reset this section', disabled: resetting, onClick: handleReset } : null}
      colorTheme={colorTheme}
    />
  )
}

BadData.propTypes = {
  sectionKey: PropTypes.string,
  reportParams: PropTypes.object,
  colorTheme: PropTypes.array,
  onReset: PropTypes.func
}

export default BadData
